export const getRGBColor = ({r ,g, b}) => {
    return `rgb(${r},${g},${b})`;
}

export const parseToChartData = (data) => {
    const { symbols, holdingPercentages, colors, transparentColors } = data.reduce((dataObj, item) => {
        const { symbols, holdingPercentages, colors, transparentColors } = dataObj;
        const { r, g, b } = item.color;

        symbols.push(item.popup);
        holdingPercentages.push(parseFloat(item.holding_pct.toFixed(2)));
        colors.push(`rgb(${r},${g},${b})`);
        transparentColors.push(`rgb(${r},${g},${b},0)`);

        return dataObj;
    }, { symbols: [], holdingPercentages: [], colors: [], transparentColors: [] })

    return { symbols, holdingPercentages, colors, transparentColors };
}